/**
 * Centralna konfiguracja oferty.
 * Wklej prawdziwy adres checkoutu w CHECKOUT_URL przed publikacją.
 */
export const CHECKOUT_URL = '';

export const PRICE = '17 USD';

export const DAILY_CAMPAIGN = {
  enabled: true,
  timezone: 'Europe/Warsaw',
  cutoff: '23:59:59',
  dateLabel: true,
  price: PRICE,
  checkoutUrl: CHECKOUT_URL,
};

export const REFUND_POLICY = {
  enabled: false,
  days: 0,
  text: '',
};

/** Link CTA: checkout, jeśli skonfigurowany — w przeciwnym razie sekcja oferty. */
export function ctaHref(): string {
  return CHECKOUT_URL || '#oferta';
}

export function ctaIsExternal(): boolean {
  return Boolean(CHECKOUT_URL);
}
